import { render } from "./SideBar.vue?vue&type=template&id=e7a85e12&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=e7a85e12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e7a85e12"

export default script